import React from "react";
import AppContext from "../../../contexts/AppContext";
import "./HomeBanner.css";


export class HomeSearch extends React.Component {
    state = { 
        searchInput:''
    }
 onChange = field => {
     if(field.target.name == 'searchInput'){
        this.setState({ searchInput: field.target.value });
     }
};
 callSearch=(event)=>{
    event.preventDefault();
     window.location ='/jobs/?q=' + encodeURIComponent(this.state.searchInput).replace(/%20/g, "+");
 }
    render() {
        return(

        <div class="home-search-panel mb-4">
            <form>
                <div className="search-box">
                    <input type="text" onChange={this.onChange} name="searchInput" id="searchInput" placeholder="Search writing jobs..."/>
                    <span class="searchIcon"> &#9906; </span>
                    <button class="search-btn" onClick={this.callSearch}>Search</button>
                </div>
            </form>
        </div>


        )
    }
}

HomeSearch.contextType = AppContext;
export default HomeSearch;


// WEBPACK FOOTER //
// ./src/components/general/include/HomeSearch.js